import { useRef, useEffect } from 'react';

/**
 * Holds state of previous value
 * @param {*} value
 * @returns {*} value
 */
export function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
